import useProductsForAssociationList from "@/hooks/useProductsForAssociationList"

const useProductsForInstructionList = useProductsForAssociationList

export default useProductsForInstructionList
